module.exports = __webpack_public_path__ + "static/weighted-quick-union-6dcb2433f67d42a6354d47340fbf4615.png";